// ActivityPopup.jsx
// Shared big-modal chrome for the five activity popups (mirror/book/tablet/
// safe/chest) — matches room.php's `.modal-content1` shell (title + body +
// submit button). Phase 3: no close button by default — matches PHP exactly
// (its Bootstrap modals use `data-keyboard="false"` and have no X; they're
// only dismissed by completing the activity). Phase 2 had added a close
// button here as a shell-preview convenience; that's removed now that real
// submit logic exists, per the Phase 3 "don't let players bypass completion"
// rule. `onClose` stays as an opt-in prop in case a future phase needs it.
import React from 'react';
import GamePopup from './GamePopup';
import './ActivityPopup.css';

/*
 * room.php uses three different title structures across the five modals,
 * confirmed by reading each one rather than assuming they all match Mirror:
 *   - myModal (Mirror):  real Bootstrap .modal-header/.modal-title, bordered,
 *     inline font-weight:bolder.
 *   - myModal2 (Book):   bare <h1 class="mob-heading">, no border, no
 *     font-weight override at all -> renders at normal weight.
 *   - myModal3 (Tablet): <h3 class="quiz-title"> with only a color inline
 *     style, no border -> renders at the browser's default (bold) heading
 *     weight, but with no divider band.
 * `plainHeader` controls the bordered-band layout (border-bottom + its own
 * padding); `boldTitle` controls weight independently, since those two
 * vary independently across the three cases above.
 */
function ActivityPopup({
  open,
  onClose,
  title,
  subtitle,
  children,
  footer,
  testId,
  plainHeader = false,
  boldTitle = true,
}) {
  return (
    <GamePopup
      open={open}
      onClose={onClose}
      closeButton={Boolean(onClose)}
      size="big"
      ariaLabel={title}
      testId={testId}
    >
      {title &&
        (plainHeader ? (
          <>
            <h3
              className={`escape-activity-title escape-activity-title--plain${
                boldTitle ? '' : ' escape-activity-title--plain-normal'
              }`}
            >
              {title}
            </h3>
            {subtitle && <h4 className="escape-activity-subtitle">{subtitle}</h4>}
          </>
        ) : (
          <div className="escape-activity-header">
            <h3 className="escape-activity-title">{title}</h3>
            {subtitle && <h4 className="escape-activity-subtitle">{subtitle}</h4>}
          </div>
        ))}
      <div className="escape-activity-body">
        {children}
        {footer && <div className="escape-activity-footer">{footer}</div>}
      </div>
    </GamePopup>
  );
}

export default ActivityPopup;
